import { useMutation } from "@tanstack/vue-query";
import type { ScheduleEmailParams } from "./types";

/**
 * Composable for scheduling emails.
 * Uses dynamic import for ScheduledEmailService to keep the bundle lean.
 */
export function useScheduleEmail() {
  const scheduleEmailMutation = useMutation({
    mutationFn: async (params: ScheduleEmailParams) => {
      const ScheduledEmailService = (await import("@/services/scheduled-email")).default;
      const response = await ScheduledEmailService.createScheduledEmail(params.payload);
      return response.data;
    },
  });

  return {
    scheduleEmail: scheduleEmailMutation.mutateAsync,
    isScheduling: scheduleEmailMutation.isPending,
    scheduleError: scheduleEmailMutation.error,
  };
}
